import { calculateDeliveryTime } from './dtc-helper-functions.js'

document.addEventListener('DOMContentLoaded', () => {
  const benefitBlockDescription = document.querySelectorAll('[id^="BenefitBlockEstimatedDelivery-"]')

  if(benefitBlockDescription.length === 0) return

  ;[...benefitBlockDescription].forEach(description => {
    const days = description.getAttribute('data-days')
    const delayDays = description.getAttribute('data-delay-days')
    const deliveryTime = calculateDeliveryTime(days, delayDays)

    description.innerHTML = deliveryTime.outerHTML
  })
})
